<div class="tab-inner-content">
    <h2>Day Book Report</h2>
    <h5>
      Date {{ chooseDate | date : "MM/d/YYYY" }}
    </h5>
    <table>
      <tr>
        <th>Account Name</th>
        <th>Journal No</th>
        <th>Debit (In AED)</th>
        <th>Credit (In AED)</th>
      </tr>
      <tr class="sub-total" *ngFor="let item of dayBookReportData?.entries ">
        <td>{{ item.accountName }}</td>
        <td>{{ item.journalNo }}</td>
        <td>{{ item.debit | number : "1.2-2" }}</td>
        <td>{{ item.credit | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="dayBookReportData?.entries?.length !== 0"  class="title">
        <td>Total</td>
        <td></td>
        <td>AED {{ dayBookReportData?.totalDebit | number : "1.2-2" }}</td>
        <td>AED {{ dayBookReportData?.totalCredit | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="dayBookReportData?.entries?.length === 0">
        <td colspan="4" class="no-data">
          No data available
        </td>
      </tr>
    </table>
  </div>
  